module.exports = __webpack_public_path__ + "img/sweden-external-causes-male.e7cca38d.png";